module.exports = __webpack_public_path__ + "static/media/LA cezzanne.157d1758.png";